(() => {
  if (navigator.deviceMemory && navigator.deviceMemory < 4) {
    return;
  }

  window.swinger.observer.initialize('.swinger-explosion__canvas', (canvas) => {
    /* eslint-disable */

    // Little Canvas things
    const ctx = canvas.getContext('2d');

    // Set Canvas to be window size
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    window.addEventListener('resize', () => {
      canvas.width = innerWidth;
      canvas.height = innerHeight;
    });

    // Configuration, Play with these
    const config = {
      particleNumber: 3000,
      maxParticleSize: Math.ceil(window.innerWidth / 150),
      maxSpeed: 100,
      colorVariation: 50,
    };

    // Colors
    const colorPalette = {
      bg: { r: 255, g: 255, b: 255 },
      matter: [
        { r: 255, g: 223, b: 0 },
        { r: 218, g: 165, b: 32 }, // darkPRPL
        { r: 255, g: 215, b: 0 }, // rockDust
        // solorFlare
        { r: 230, g: 190, b: 138 }, // totesASun
      ],
    };

    // Some Variables hanging out
    let particles = [];

    // Draws the background for the canvas, because space
    const drawBg = function (ctx, color) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    // Particle Constructor
    const Particle = function (x, y) {
      // X Coordinate
      this.x = x || Math.round(Math.random() * canvas.width);
      // Y Coordinate
      this.y = y || Math.round(Math.random() * canvas.height);
      // Radius of the space dust
      this.r = Math.ceil(Math.random() * config.maxParticleSize);
      // Color of the rock, given some randomness
      this.c = colorVariation(colorPalette.matter[Math.floor(Math.random() * colorPalette.matter.length)], true);
      // Speed of which the rock travels
      this.s = Math.ceil(Math.random() * config.maxSpeed) ** 0.7;
      // Direction the Rock flies
      this.d = Math.round(Math.random() * 360);
    };

    // Provides some nice color variation
    // Accepts an rgba object
    // returns a modified rgba object or a rgba string if true is passed in for argument 2
    var colorVariation = function (color, returnString) {
      let r; let g; let b; let a; let
        variation;
      r = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation / 2)) + color.r);
      g = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation / 2)) + color.g);
      b = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation / 2)) + color.b);
      a = Math.random() + 0.5;
      if (returnString) {
        return `rgba(${r},${g},${b},${a})`;
      }
      return {
        r, g, b, a,
      };
    };

    // Used to find the rocks next point in space, accounting for speed and direction
    const updateParticleModel = function (p) {
      const a = 180 - (p.d + 90); // find the 3rd angle
      p.d > 0 && p.d < 180 ? p.x += p.s * Math.sin(p.d) / Math.sin(p.s) : p.x -= p.s * Math.sin(p.d) / Math.sin(p.s);
      p.d > 90 && p.d < 270 ? p.y += p.s * Math.sin(a) / Math.sin(p.s) : p.y -= p.s * Math.sin(a) / Math.sin(p.s);
      p.y += 20;
      return p;
    };

    // Just the function that physically draws the particles
    // Physically? sure why not, physically.
    const drawParticle = function (x, y, r, c) {
      ctx.beginPath();
      ctx.fillStyle = c;
      ctx.arc(x, y, r, 0, 2 * Math.PI, false);
      ctx.fill();
      ctx.closePath();
    };

    // Remove particles that aren't on the canvas
    const cleanUpArray = function () {
      particles = particles.filter((p) => (p.x > -100 && p.y > -100));
    };

    const initParticles = function (numParticles, x, y) {
      for (let i = 0; i < numParticles; i++) {
        particles.push(new Particle(x, y));
      }
      particles.forEach((p) => {
        drawParticle(p.x, p.y, p.r, p.c);
      });
    };

    // Our Frame function
    const frame = function () {
      // Draw background first
      drawBg(ctx, colorPalette.bg);
      // Update Particle models to new position
      particles.map((p) => updateParticleModel(p));
      // Draw em'
      particles.forEach((p) => {
        drawParticle(p.x, p.y, p.r, p.c);
      });
      // Play the same song? Ok!
      window.requestAnimationFrame(frame);
    };

    let timer;

    // Click listener
    document.addEventListener('swinger:explode', (e) => {
      const elem = window.swinger.eventHub.getTarget(e);
      const { x, y, width, height } = elem.getBoundingClientRect();

      cleanUpArray();
      initParticles(config.particleNumber, (x + (width / 2)), (y + (height / 2)));

      const wrapper = canvas.closest('.swinger-explosion');
      const flare = wrapper.querySelector('.swinger-explosion__flare');
      window.clearTimeout(timer);
      flare.style.display = 'block';
      timer = window.setTimeout(() => {
        flare.style.display = '';
      }, 1000);

      if (
        window.navigator
        && navigator.vibrate
      ) {
        try {
          navigator.vibrate(100);
        } catch (e) {
          console.error(e);
        }
      }

    });

    // First Frame
    frame();
  }, false);
})();
